// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2UVxE","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3XUI5"};